import * as React from "react";
import styled from "styled-components";
import { select } from "@hubper/theme";

import Text from "../../elements/Text";

const Base = styled.div`
  width: 100%;
  height: ${select.space(3)};
  background-color: ${select.color(["grey", 1])};
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2px;
  position: relative;
  overflow: hidden;
`;

const InnerBar = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  background-color: ${select.color(["success", 4])};
`;

type Props = {
  style?: React.CSSProperties;
  className?: string;
  progress: number;
};

function ProgressBar({ style, className, progress = 0 }: Props, ref: any) {
  const showInsideBar = progress < 100 && progress > 0;
  const showLeftSide = progress > 24;

  return (
    <Base ref={ref} style={style} className={className}>
      <InnerBar style={{ width: `${progress}%` }}>
        {showInsideBar && (
          <Text
            c={showLeftSide ? ["success", 0] : ["grey", 7]}
            style={{
              position: "absolute",
              right: showLeftSide ? 10 : undefined,
              left: !showLeftSide ? "calc(100% + 10px)" : undefined,
              top: "50%",
              transform: "translateY(-50%)"
            }}
            fs={-2}
          >
            {Math.round(progress)}%
          </Text>
        )}
      </InnerBar>
      {!showInsideBar && (
        <Text
          style={{ zIndex: 1 }}
          fs={-2}
          c={progress === 0 ? ["grey", 7] : ["success", 0]}
        >
          {Math.round(progress)}%
        </Text>
      )}
    </Base>
  );
}

export default React.forwardRef(ProgressBar);
